module.exports = __webpack_public_path__ + "img/动态模版背景.45bdd9ea.png";